h1{text-align:center}.form-group{margin-bottom:16px}.btn{width:100%}.forgot-link a{font-size:14px;font-weight:500}
/*# sourceMappingURL=mfa-recovery-form.component-DGFJYAV6.css.map */
